
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */
import { TextLink, Text, LinkUnderlined } from '@drawbotics/react-drylus';
import Playground from '~/components/Playground';


const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


<h1>{`Text Link`}</h1>
<p>{`This component is to be used if you need to style a link in a piece of text, it does not provide the actual "linking" functionality.`}</p>
<pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`import { TextLink, LinkUnderlined } from '@drawbotics/react-drylus';
`}</code></pre>
<p><strong parentName="p">{`Example`}</strong></p>
<Playground __position={0} __code={`<Text>This is some normal text and there is a </Text><TextLink>link</TextLink><Text> within it</Text>`} component={TextLink} enums={{
      LinkUnderlined
    }} mdxType="Playground">
  <Text mdxType="Text">This is some normal text and there is a </Text><TextLink mdxType="TextLink">link</TextLink><Text mdxType="Text"> within it</Text>
</Playground>
<p>{`Any other prop you pass is spread to the `}<inlineCode parentName="p">{`span`}</inlineCode>{` element.`}</p>
<p>{`Normally the framework you use should provide a `}<inlineCode parentName="p">{`Link`}</inlineCode>{` component for navigation, which you can use like this:`}</p>
<pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`import { Link } from 'my-framework';
import { TextLink } from '@drawbotics/react-drylus';

// ...
  return (
    <Link to="some url">
      <TextLink>Click me to navigate</TextLink>
    </Link>
  );
// ...
`}</code></pre>
    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;